
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('jquery-ui');
require('jquery-ui/ui/widgets/sortable');
require('tinymce');
require('@fancyapps/fancybox');

require('./components/form_submit');
require('./components/sortable');
require('./components/tabs');
require('./components/multi_option_filter');
require('./components/form_switch_container');
require('./components/tinymce/source');
require('./components/tinymce/tinymce');

$('[role="tablist"] a').click(function (e) {
    e.preventDefault();
    $(this).tab('show');
});